var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.id)?_c('div',[(_vm.topicInProgress)?_c('TopicPostComponent',{attrs:{"editTopic":_vm.topicInProgress}}):_vm._e()],1):_c('div',[_c('TopicPostComponent')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }